import axios from 'axios'
import Authentication from "../Authentication"
import User from "../../models/User"


/**
* @class
* Module which provides user manager capabilities for AWS cloud provider
**/
export default  class AWSAuthentication extends Authentication{ 

    constructor(context,settings){
        super()
        this.context = context
        this.settings_oauth2 = settings.authentication.oauth2[settings.env]
        this.settings_authz = settings.authentication.authz[settings.env]
    }   

    CreateUser(){
        return new Promise(
            (resolve,)=>{
                resolve()
            })
    }

    async CheckLogin(){


        if(localStorage.getItem('login_process')){
            localStorage.removeItem('login_process')
            await this.Login() 
             
        }

        // AuthN tokes got as query string parameters
        let urlParams = new URLSearchParams(window.location.search)
        if(urlParams.has("id_token") && urlParams.has("access_token"))
            this._setAuthNCredentials(
                urlParams.get("id_token"),
                urlParams.get("access_token"),
                "",
                ""+((new Date()).getTime()+4*60*1000),
                ""
            )
        // \ end

        let authNCredentials = this.AuthNCredentials()
        let authZCredentials = this.Credentials()

        if(authNCredentials.expires_in){
            if((authNCredentials.expires_in - 2*60*1000 - (new Date()).getTime()) > 0){
                return new Promise((resolve,reject)=> {
                    if(!this._getLicenseAgreementChecked(authNCredentials.id_token)){
                        reject({laChecked: false});
                        return;
                    }
                    axios.get(this.settings_authz.url,{headers:{'Authorization':authNCredentials.id_token}})
                    .then(
                        () => {
                            // console.log(this._getIndentitySubClaim(authNCredentials.id_token))
                            let credentials = {
                                username:authZCredentials.username,
                                principalId:authZCredentials.principalId,
                                accessKeyId:authZCredentials.accessKeyId,
                                secretAccessKey:authZCredentials.secretAccessKey,
                                sessionToken:authZCredentials.sessionToken,
                                expiration:parseInt(authZCredentials.expiration),
                                sub: this._getIndentitySubClaim(authNCredentials.id_token)
                            }
                            
                            resolve(new User(authZCredentials.username,null,null,credentials))
                        }
                    )
                    .catch((e)=>reject(e))
                })
            }
        }
    }

    Login(user,type){
        // if there is: ( authz code in query ) or (valid tokens in cache)*
        // then request tokens (and store them) if need and return 
        let query = null
        let p = this._autoLogin()
        if(p){
            return p
        }

        localStorage.setItem('login_process',"true")
        switch(type){
            case "google":
                query = this.settings_oauth2.authorize.query 
                break
            case "saml":
                query = this.settings_oauth2.authorize.samlquery 
                break
            default:
                throw "IdP unknown"
        }

        return new Promise(
            (resolve)=>{
                window.location.href= this.settings_oauth2.base +
                    this.settings_oauth2.authorize.path + 
                    query//this.settings_oauth2.authorize.query 
                resolve()
            })

            
    }

    RefreshCredentials(){
        let authNCredentials = this.AuthNCredentials()
        let now = (new Date()).getTime()
        let url = 
            this.settings_oauth2.base +
            this.settings_oauth2.refresh_token.path
        let body = this.settings_oauth2.refresh_token.body1 + "&refresh_token="+authNCredentials.refresh_token +this.settings_oauth2.refresh_token.body2
        let headers = this.settings_oauth2.refresh_token.headers
        return new Promise(
            (resolve,reject) => {
                axios.post(
                    url,
                    body,
                    {headers:headers})
                .then(
                    async (res) => {
        
                        this._setAuthNCredentials(
                            res.data.id_token,
                            res.data.access_token,
                            authNCredentials.refresh_token,
                            res.data.expires_in*1000+now,
                            authNCredentials.code
                        )
                        if(!this._getLicenseAgreementChecked(res.data.id_token)){
                            reject({laChecked: false});
                            return;
                        }
                        let userInfoUrl = this.settings_oauth2.base + this.settings_oauth2.userInfo.path
                        let userInfo = await axios.get(userInfoUrl,{headers:{'Authorization':'Bearer '+res.data.access_token}})
                        axios.get(this.settings_authz.url,{headers:{'Authorization':res.data.id_token}})
                        .then(
                            (res) => {
                                this._setCredentials(
                                    userInfo.data.email,
                                    res.data.IdentityId,
                                    res.data.Credentials.AccessKeyId,
                                    res.data.Credentials.SecretKey,
                                    res.data.Credentials.SessionToken,
                                    Date.parse(res.data.Credentials.Expiration)
                                )
                                resolve(res);
                            }
                        )
                        .catch((e)=>reject(e))
                    }
                )
            }
        ) 
        
    }

    AcceptLA(){
        let authNCredentials = this.AuthNCredentials()
        return new Promise(
            (resolve,reject) =>{
                axios.get(this.settings_authz.url,{headers:{'Authorization':authNCredentials.id_token}, params: { AccessToken: authNCredentials.access_token}})
                .then( (d) => resolve(d))
                .catch((e)=>reject(e))
            }
        )
    }

    Logout(){
        return new Promise(
            (resolve)=>{
                this._clearAuthNCredentials()
                this._clearCredentials()
                window.location.href=
                    this.settings_oauth2.base +
                    this.settings_oauth2.logout.path + 
                    this.settings_oauth2.logout.query
                resolve()
            })
    }

    /**
     * @method Credentials Retrieve from store credentials of logged user
     * @returns {object} Credentials object
     */
    Credentials(){
        return {
            username:localStorage.getItem('username'),
            principalId:localStorage.getItem('principalId'),
            accessKeyId:localStorage.getItem('accessKeyId'),
            secretAccessKey:localStorage.getItem('secretAccessKey'),
            sessionToken:localStorage.getItem('sessionToken'),
            expiration:parseInt(localStorage.getItem('expiration')),
            sub: this._getIndentitySubClaim(this.AuthNCredentials().id_token)
        }
    }

    /**
     * @method AuthNCredentials Retrieve from store authentication credentials of logged user
     * @returns {object} AuthNCredentials object
     */
    AuthNCredentials(){
        return {
            id_token:localStorage.getItem('id_token'),
            access_token:localStorage.getItem('access_token'),
            refresh_token:localStorage.getItem('refresh_token'),
            expires_in:parseInt(localStorage.getItem('expires_in')),
            code:localStorage.getItem('code')
        }
    }

    /**
     * @method autoLogin  Login with stored user credentials (auth tokens)
     * @private
     */
    _autoLogin(){
        let urlParams = new URLSearchParams(window.location.search)

        // AuthN tokes got as query string parameters
        if(urlParams.has("id_token") && urlParams.has("access_token"))
            this._setAuthNCredentials(
                urlParams.get("id_token"),
                urlParams.get("access_token"),
                "",
                ""+((new Date()).getTime()+4*60*1000),
                ""
            )
        // \ end

        let authNCredentials = this.AuthNCredentials()
        let authZCredentials = this.Credentials()
        if(authNCredentials.expires_in){
            if((authNCredentials.expires_in - 2*60*1000 - (new Date()).getTime()) > 0){
                return new Promise((resolve,reject)=> {
                    if(!this._getLicenseAgreementChecked(authNCredentials.id_token)){
                        reject({laChecked: false});
                        return;
                    }

                    axios.get(this.settings_authz.url,{headers:{'Authorization':authNCredentials.id_token}})
                    .then(
                        () => {
                            let credentials = {
                                username:authZCredentials.username,
                                principalId:authZCredentials.principalId,
                                accessKeyId:authZCredentials.accessKeyId,
                                secretAccessKey:authZCredentials.secretAccessKey,
                                sessionToken:authZCredentials.sessionToken,
                                expiration:parseInt(authZCredentials.expiration),
                                sub: this._getIndentitySubClaim(authNCredentials.id_token)
                            }
                            
                            resolve(new User(authZCredentials.username,null,null,credentials))
                        }
                    )
                    .catch((e)=>reject(e))
                })
            }
        }

        if(urlParams.has('code'))
        {
            if(authNCredentials.code!=urlParams.get('code'))
                return new Promise(
                    (resolve,reject) => {
                        let now = (new Date()).getTime()
                        let url = 
                            this.settings_oauth2.base +
                            this.settings_oauth2.token.path
                        let body = this.settings_oauth2.token.body1 + "&code="+urlParams.get('code') +this.settings_oauth2.token.body2
                        let headers = this.settings_oauth2.token.headers
                        axios.post(
                            url,
                            body,
                            {headers:headers})
                        .then(
                            async (res) => {
                                this._setAuthNCredentials(
                                    res.data.id_token,
                                    res.data.access_token,
                                    res.data.refresh_token,
                                    res.data.expires_in*1000+now,
                                    urlParams.get('code')
                                )
                                if(!this._getLicenseAgreementChecked(res.data.id_token)){
                                    reject({laChecked: false});
                                    return;
                                }
                                let userInfoUrl = this.settings_oauth2.base + this.settings_oauth2.userInfo.path
                                let userInfo = await axios.get(userInfoUrl,{headers:{'Authorization':'Bearer '+res.data.access_token}})
                                axios.get(this.settings_authz.url,{headers:{'Authorization':res.data.id_token}})
                                .then(
                                    (res) => {
                                        // let credentials = {
                                        //     username:userInfo.data.email,
                                        //     principalId:res.data.IdentityId,
                                        //     accessKeyId:res.data.Credentials.AccessKeyId,
                                        //     secretAccessKey:res.data.Credentials.SecretKey,
                                        //     sessionToken:res.data.Credentials.SessionToken,
                                        //     expiration:Date.parse(res.data.Credentials.Expiration)
                                        // }
                                        this._setCredentials(
                                            userInfo.data.email,
                                            res.data.IdentityId,
                                            res.data.Credentials.AccessKeyId,
                                            res.data.Credentials.SecretKey,
                                            res.data.Credentials.SessionToken,
                                            Date.parse(res.data.Credentials.Expiration)
                                        )
                                        window.location.href = window.location.protocol + "//" + window.location.host + "/"
                                        // resolve(new User(userInfo.data.email,null,null,credentials))
                                    }
                                )
                                .catch((e)=>reject(e))
                            }
                        )
                        .catch((e)=>reject(e))
                    }
                )
        }



    }

    /**
     * @private
     * @method _setCredentials Set user credentials in local storage if defined, otherwise skip value
     * @param username Username
     * @param principalId Principal user is
     * @param accessKeyId Access key id
     * @param secretAccessKey Secret key id
     * @param sessionToken Session token
     * @param expiration Expiration time in millis
     */
    _setCredentials(
        username,
        principalId,
        accessKeyId,
        secretAccessKey,
        sessionToken,
        expiration
    ){
        if(username)localStorage.setItem('username',username)
        if(principalId)localStorage.setItem('principalId',principalId)
        if(accessKeyId)localStorage.setItem('accessKeyId',accessKeyId)
        if(secretAccessKey)localStorage.setItem('secretAccessKey',secretAccessKey)
        if(sessionToken)localStorage.setItem('sessionToken',sessionToken)
        if(expiration)localStorage.setItem('expiration',expiration+"")
    }

    /**
     * @private
     * @method _clearCredentials Remove credentials from local storage
     */
    _clearCredentials(){
        localStorage.removeItem('username')
        localStorage.removeItem('principalId')
        localStorage.removeItem('accessKeyId')
        localStorage.removeItem('secretAccessKey')
        localStorage.removeItem('sessionToken')
        localStorage.removeItem('expiration')
    }

    /**
     * @private
     * @method _setAuthNCredentials Set user authentication credentials in local storage if defined, otherwise skip value
     * @param id_token OpenIdConnect token
     * @param access_token OAuth2.0 token
     * @param refresh_token Refresh token
     * @param expires_in Tokens expirations time
     */
    _setAuthNCredentials(
        id_token,
        access_token,
        refresh_token,
        expires_in,
        code
    ){
        if(id_token)localStorage.setItem('id_token',id_token)
        if(access_token)localStorage.setItem('access_token',access_token)
        if(refresh_token)localStorage.setItem('refresh_token',refresh_token)
        if(expires_in)localStorage.setItem('expires_in',expires_in+"")
        if(code)localStorage.setItem('code',code+"")
    }

    /**
     * @private
     * @method _clearAuthNCredentials Remove authentication credentials from local storage
     */
    _clearAuthNCredentials(){
        localStorage.removeItem('id_token')
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        localStorage.removeItem('expires_in')
        localStorage.removeItem('code')
    }

    _getLicenseAgreementChecked(id_token){
        let claims = JSON.parse(atob(id_token.split(".")[1]));
        return claims["custom:license_agreement"] == "1";
    }

    _getIndentitySubClaim(id_token){
        if(!id_token)
            return
        let claims = JSON.parse(atob(id_token.split(".")[1]));
        return claims["sub"];
    }

}